import { render, staticRenderFns } from "./Configuraciones.vue?vue&type=template&id=2f629f95&scoped=true"
import script from "./Configuraciones.vue?vue&type=script&setup=true&lang=js"
export * from "./Configuraciones.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Configuraciones.vue?vue&type=style&index=0&id=2f629f95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f629f95",
  null
  
)

export default component.exports